import { useQuery } from 'react-query';
import { reporteService } from '../../services/reporteService';
import { Link } from 'react-router-dom';

const ReportesDashboard = () => {
  const { data, isLoading } = useQuery(
    'dashboard-reportes',
    () => reporteService.getDashboard()
  );

  if (isLoading) {
    return <div className="text-center py-8">Cargando...</div>;
  }

  const dashboard = data?.data;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Ventas del Día</h3>
          <p className="text-3xl font-bold text-gray-900">
            ${dashboard?.ventasHoy.toFixed(2) || '0.00'}
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Órdenes del Día</h3>
          <p className="text-3xl font-bold text-gray-900">
            {dashboard?.ordenesHoy || 0}
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-sm font-medium text-gray-500 mb-2">Sesiones Abiertas</h3>
          <p className="text-3xl font-bold text-gray-900">
            {dashboard?.sesionesAbiertas || 0}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Link
          to="/reportes/ventas"
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition"
        >
          <h3 className="font-semibold text-gray-800 mb-2">Reporte de Ventas</h3>
          <p className="text-sm text-gray-600">
            Análisis de ventas por período, sucursal y producto
          </p>
        </Link>

        <Link
          to="/reportes/productos"
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition"
        >
          <h3 className="font-semibold text-gray-800 mb-2">Productos Más Vendidos</h3>
          <p className="text-sm text-gray-600">
            Top productos y análisis de movimientos
          </p>
        </Link>

        <Link
          to="/reportes/arqueos"
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition"
        >
          <h3 className="font-semibold text-gray-800 mb-2">Arqueos de Caja</h3>
          <p className="text-sm text-gray-600">
            Resumen de cierres y diferencias
          </p>
        </Link>

        <Link
          to="/reportes/inventario"
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition"
        >
          <h3 className="font-semibold text-gray-800 mb-2">Movimientos de Inventario</h3>
          <p className="text-sm text-gray-600">
            Entradas, salidas y análisis de stock
          </p>
        </Link>
      </div>
    </div>
  );
};

export default ReportesDashboard;

